import * as consts from './saleConst';

export const flags = {
  USD: 'flag-us',
  CAD: 'flag-ca',
  GBP: 'flag-uk',
  AUD: 'flag-au',
  EUR: 'flag-eu',
  SGD: 'flag-sgp',
  MXN: 'flag-mxn'
};

export const _lng = {
  'en-US': {
    label: 'English',
    flag: flags.USD
  },
  'fr-CA': {
    label: 'Français',
    flag: 'flag-fr'
  },
  'mxn-MXN': {
    label: 'Méjico',
    flag: flags.MXN
  }
};

export const currency = {
  USD: '$',
  CAD: '$',
  GBP: '£',
  AUD: '$',
  EUR: '€',
  SGD: '$',
  MXN: '$'
};

// eslint-disable-next-line
export const emailRegexp = /^[a-zA-Z0-9]+([\w\.\'\!\#\$\%\&\*\+\-\/\=\?\^\`\{\|\}\~])*([a-zA-Z0-9])+@([a-zA-Z0-9\d.\-]+\.+)+[a-zA-Z0-9]{2,8}$/
export const isNumberRegexp = /^\d+$/;
export const isURLRegexp = /^(?!\d*$)([A-z0-9][A-z0-9_\-]*)$/;
export const phoneRegexp = /^[a-zA-Z0-9.\-\+\(\)]*$/;

export const timeerOffModal = 2500;

export const SummenrNoteToolbar = [
  ['style', ['bold', 'italic', 'underline']],
  ['insert', ['link']],
  ['font', ['strikethrough', 'fontsize']],
  ['forecolor'],
  ['backcolor'],
  ['para', ['ul', 'ol', 'paragraph']],
  ['height', ['height']]
];

export const SummenrNoteToolbarHeight10Lines = 250;

export const encryptKey = 'sparxo*!*';

/** FeeType */
export const TicketFeeType = {
  IncludeFee: 'IncludeFee', // 1
  ExcludeFee: 'ExcludeFee' // 2
};

export const MaxOrderQuantity = 50;

export const AssignEventPermission = {
  Read: 'Read',
  Write:'Write'
};

export const QuestionAskTo = consts.QuestionAskTo;
export const QuestionDisplayType = consts.QuestionDisplayType;
export const FacebookPageShareUrlWay = consts.FacebookPageShareUrlWay;
export const RewardItem = consts.RewardItem;
export const RewardAccordingTo = consts.RewardAccordingTo;

export const FB_APP_ID = 1734065270200892;
